import { nonNull } from '@helpers/non-null';

export enum AUTHORIZATION_PROVIDERS {
  EMAIL = 'auth0',
  GOOGLE = 'google-oauth2'
}

export const NODE_ENV = nonNull(process.env.NODE_ENV);
export const APP_BASE_URL = nonNull(
  process.env.REACT_APP_APP_BASE_URL,
  'REACT_APP_APP_BASE_URL'
)
  .split(',')
  .map((x) => x.trim());
export const API_BASE_URL = nonNull(
  process.env.REACT_APP_API_BASE_URL,
  'REACT_APP_API_BASE_URL'
);
export const WEBSOCKET_URL = nonNull(
  process.env.REACT_APP_WEBSOCKET_URL,
  'REACT_APP_WEBSOCKET_URL'
);

export const AUTH0_CLIENT_ID = nonNull(
  process.env.REACT_APP_AUTH0_CLIENT_ID,
  'REACT_APP_AUTH0_CLIENT_ID'
);
export const AUTH0_DOMAIN = nonNull(
  process.env.REACT_APP_AUTH0_DOMAIN,
  'REACT_APP_AUTH0_DOMAIN'
);
export const AUTH0_AUDIENCE = nonNull(
  process.env.REACT_APP_AUTH0_AUDIENCE,
  'REACT_APP_AUTH0_AUDIENCE'
);
export const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY;
export const KNOCK_PUBLIC_KEY = nonNull(
  process.env.REACT_APP_KNOCK_PUBLIC_KEY,
  'REACT_APP_KNOCK_PUBLIC_KEY'
);
export const KNOCK_FEED_ID = nonNull(
  process.env.REACT_APP_KNOCK_FEED_ID,
  'REACT_APP_KNOCK_FEED_ID'
);
export const RECAPTCHA_V3_SITE_KEY = nonNull(
  process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY,
  'REACT_APP_RECAPTCHA_V3_SITE_KEY'
);

export const ASANA_CLIENT_ID = nonNull(
  process.env.REACT_APP_ASANA_CLIENT_ID,
  'REACT_APP_ASANA_CLIENT_ID'
);

export const MONDAY_CLIENT_ID = nonNull(
  process.env.REACT_APP_MONDAY_CLIENT_ID,
  'REACT_APP_MONDAY_CLIENT_ID'
);

export const NEW_ONBOARDING_RELEASE_DATE = new Date('2025-06-10T13:00:15.051Z');

export const DEMO_SUBDOMAIN = 'demo';

// DEMO TOUR
export const DEMO_TOUR_WORKSPACE_ID = '6c9ace4b-466f-46e6-ad9d-57af44c4cb8f';
export const DEMO_TOUR_APPROVAL_WORKFLOW_ID =
  '2574e4a1-5cc0-5c48-ae13-8189beeb7ab7';
export const DEMO_TOUR_MEDIA_VIEWER_ASSET_ID =
  '086496a4-f942-5d7e-9d87-173794321a02';
export const DEMO_TOUR_MEDIA_VIEWER_TASK_ID =
  '11c82bf8-b0df-5fdc-8b46-82b788e19858';
export const DEMO_TOUR_MEDIA_VIEWER_COMMENT_ID =
  '8841f8ae-4726-5375-9404-fd1a43b22e7c';
export const DEMO_TOUR_MEDIA_VIEWER_ANNOUNCEMENT_ASSET_ID =
  '6505be0d-6b95-5658-b9a7-2cd94106cb68';

export const IGNORE_NON_LTI_LOGIN_ERROR_KEY = 'ignore-non-lti-login-error';
